import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/components/FavoriteButton/client.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/InputSearch.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/HeroesSorter.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/HeartSwitch.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/Pagination.tsx")